module.exports = __webpack_public_path__ + "img/s1.8b7515b5.svg";